<template>
    <div class="Details">
    <section>
        <div class="content">
            
            <h4 class="title is-6 box">
                Labeling lets you work with human labelers to generate highly accurate labels for a collection of data that you can use in machine learning models.
            </h4>
            
            <div v-if="dataset.labeling">
                <b-message type="is-success">
                    You requested a human labeling service! We are contacting our teams and will return to you with quotation and estimated time.
                    <br><br>
                    The resulting labeling data will appear here as a new version, and you will be able to download and/or train a model in our platform.
                </b-message>
            </div>
            <div v-else>
                <b-message class="box">
                    The labeling is performed by human labelers, we select the team of labelers that matches your requirements. All teams sign data protection responsability to keep your data safe.
                    <br><br>
                    Please, create three resources for the human labelers:
                    <br>
                    1. Datasets<br>
                    2. Labels<br>
                    3. Instructions
                    <br><br>
                    After submit your labeling task, we'll return to you with quotation and time to finished the job. The resulting labeling data will appear here as a new version, and you will be able to download and/or train a model in our platform.
                </b-message>
                <form v-on:submit.prevent="submitLabeling()" class="box">
                    <p>
                        
                        <b-field label="Datasets">
                            <b-select
                                multiple
                                native-size="3"
                                v-model="selectedDataset"
                                style="min-width: 100%;"
                                required
                                >
                                <option v-for="dataset in labeling_datasets"
                                :key="dataset.id"
                                :value="dataset">
                                {{ dataset }}
                                </option>
                            </b-select>
                        </b-field>
                    </p>
                    <p>
                        <b-field label="Labels">
                            <b-taginput
                                v-model="labels"
                                size="is-large">
                            </b-taginput>
                        </b-field>
                    </p>
                    <p>
                        <b-field label="Instructions">
                            <b-input 
                            required
                            v-model="instructions"
                            :placeholder="instructionsPlaceholder"
                            type="textarea"></b-input>
                        </b-field>
                    </p>

                    <p>
                        <b-button
                            tag="input"
                            native-type="submit"
                            label="Submit"
                            type="is-primary"/>
                    </p>
                </form>
            </div>  
                
        </div>

    </section>

    </div>
</template>
<script>
import DataFrame from 'dataframe-js';
import axios from 'axios';

import { Plotly } from 'vue-plotly'

   export default {
     props: ["dataset", "wordclouds"],
     name: "Data",
     data: function() {
    return {
        labels: ["Label A", "label B"],
        instructions: "",
        labeling_datasets: [],
        selectedDataset: [],
        instructionsPlaceholder: "Please list all the labels you would like to use and describe the meaning of each label. Suggestion: For each label, give at least 3 positive examples and 1 negative example. These examples should cover different cases.",
        json: [1],
        unbalanced: false,
        tableData: false,
        tableSort: ['label', 'text'],
        animated: true,
        balancePlot: false,
        dataset_url: null,
        data_plot: null,
        fill:  {
          
          
        },
    }},
    components: {
        Plotly
    },
    computed: {
    //    dataset() {
    //      return this.$store.state.dataset;
    //    }
     },
     methods: {
         submitLabeling(){
            const toLabeling = {
                datasetId: this.dataset.id,
                update: {
                    instructions: this.instructions || 1,
                    labels: this.labels || 1,
                    datasets_version: this.selectedDataset || 1
                }
            }

            const toUpload = {
                datasetId: this.dataset.id,
                update: {
                    labeling: true
                }
            }
            console.log(toLabeling)
            this.$store.dispatch("labelingDataset", 
                toLabeling
            );

            this.$store.dispatch("updateDataset", 
                toUpload
            );
         },
     },
     mounted(){
        
     },
     created() {
        this.labeling_datasets = [
            this.dataset.filename + " created at "+ this.dataset.createdAt.toDate()
        ]
        if (this.dataset.labelBalance){

            
            this.labels = this.dataset.labelBalance['labels']

        }
        
     }
   };
</script>
<style scoped="">
img.preview {
    width: 200px;
}

</style>